import { render, staticRenderFns } from "./Participantes.vue?vue&type=template&id=ed526732&scoped=true&"
import script from "./Participantes.vue?vue&type=script&lang=js&"
export * from "./Participantes.vue?vue&type=script&lang=js&"
import style0 from "./Participantes.vue?vue&type=style&index=0&id=ed526732&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed526732",
  null
  
)

export default component.exports